@if (activities) {
  <div>
    @for (activity of activities; track activity; let i = $index) {
      <div>
        @if (
          {
            activityStartTime: activity | ganttActivityStartTime,
            activityEndTime: activity | ganttActivityEndTime,
          };
          as data
        ) {
          <div>
            @if (
              {
                left:
                  (data.activityStartTime.date | ganttStartingPixel | async),
                right:
                  ([data.activityStartTime.date, data.activityEndTime.date]
                  | ganttEndingPixel
                  | async),
              };
              as activityData
            ) {
              @if (
                {
                  leftPx:
                    activityData.left && i === 0
                      ? activityData.left + LEFT_RIGHT_ADJUSTMENT
                      : activityData.left,
                  rightPx:
                    activityData.right && i === activities.length - 1
                      ? activityData.right + LEFT_RIGHT_ADJUSTMENT
                      : activityData.right,
                  calculatedActivityWidth:
                    activityData | timeDifferenceWidthPx | async,
                };
                as cardSizeData
              ) {
                <div>
                  <wilson-activity-card
                    [activity]="activity"
                    [leftPx]="cardSizeData.leftPx"
                    [rightPx]="cardSizeData.rightPx"
                    [calculatedActivityWidth]="
                      cardSizeData.calculatedActivityWidth
                    "
                    [accurateActivityStartDateTime]="
                      data.activityStartTime.date
                    "
                    [activityStartTimeDifference]="
                      data.activityStartTime.timeDifference
                    "
                    [accurateActivityEndDateTime]="data.activityEndTime.date"
                    [activityEndTimeDifference]="
                      data.activityEndTime.timeDifference
                    "
                    [activityStartTimeType]="data.activityStartTime.type"
                    [activityEndTimeType]="data.activityEndTime.type"
                    [dottedBorder]="dottedBorder"
                    [isHovered]="isHovered"
                    (click)="
                      handleClick(
                        $event,
                        activity.id || '',
                        cardSizeData.leftPx,
                        cardSizeData.rightPx
                      )
                    "
                  ></wilson-activity-card>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
}
